import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';
import { TreeTableModule } from 'primeng/treetable';
import { DataUsageComponent } from './components/data-usage/data-usage.component';
let DataUsageModule = class DataUsageModule {
};
DataUsageModule = __decorate([
    NgModule({
        imports: [
            CommonModule,
            FormsModule,
            ButtonModule,
            CalendarModule,
            RippleModule,
            TooltipModule,
            TreeTableModule
        ],
        declarations: [
            DataUsageComponent
        ],
        exports: [
            DataUsageComponent
        ],
    })
], DataUsageModule);
export { DataUsageModule };
export { DataUsageComponent };
